// require('../images/the-christmas-passion-crowd-small.jpg');
// require('../images/the-christmas-passion-crowd-medium.jpg');
// require('../images/the-christmas-passion-crowd-large.jpg');
// require('../images/the-christmas-passion-logo.svg');
// require('../images/the-christmas-passion-jumbotron-small.jpg');
// require('../images/the-christmas-passion-jumbotron-medium.jpg');
// require('../images/the-christmas-passion-jumbotron-large.jpg');
// require('../images/the-christmas-passion-header.svg');
// require('../images/example-logo-1.png');
// require('../images/example-logo-2.jpg');
// require('../images/example-logo-3.png');
// require('../images/example-logo-4.png');
// require('../images/example-logo-5.png');
// require('../images/twitter-icon.svg');
// require('../images/facebook-icon.svg');
// require('../images/instagram-icon.svg');
require('../images/logo-otr.jpg');
require('../images/header7.jpg');
require('../images/werkplaats-example.jpg');
require('../images/service-example.jpg');
require('../images/example-logo-Peugeot.png');
require('../images/example-logo-Yamaha.png');
require('../images/example-logo.png');
require('../images/bovag-keurmerk.png');
require('../images/RDW-erkend.png');
require('../icomoon_icons/symbol-defs.svg');





// WEBPACK FOOTER //
// ./craft/templates/src/js/template-images.js